"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEndpointBalances = void 0;
function generateEndpointBalances(address) {
    return `/cosmos/bank/v1beta1/balances/${address}`;
}
exports.generateEndpointBalances = generateEndpointBalances;
//# sourceMappingURL=balances.js.map